/**
 * Locale tiếng Việt cho ProTable và các ProComponents
 * Override các text mặc định tiếng Trung
 */
export default {
  // ProTable toolbar
  'tableForm.search': 'Tìm kiếm',
  'tableForm.reset': 'Đặt lại',
  'tableForm.submit': 'Gửi',
  'tableForm.collapsed': 'Mở rộng',
  'tableForm.expand': 'Thu gọn',
  'tableForm.inputPlaceholder': 'Vui lòng nhập',
  'tableForm.selectPlaceholder': 'Vui lòng chọn',

  // ProTable options
  'tableToolBar.leftPin': 'Ghim trái',
  'tableToolBar.rightPin': 'Ghim phải',
  'tableToolBar.noPin': 'Bỏ ghim',
  'tableToolBar.leftFixedTitle': 'Cố định bên trái',
  'tableToolBar.rightFixedTitle': 'Cố định bên phải',
  'tableToolBar.noFixedTitle': 'Không cố định',
  'tableToolBar.reset': 'Đặt lại',
  'tableToolBar.columnDisplay': 'Hiển thị cột',
  'tableToolBar.columnSetting': 'Cài đặt cột',
  'tableToolBar.fullScreen': 'Toàn màn hình',
  'tableToolBar.exitFullScreen': 'Thoát toàn màn hình',
  'tableToolBar.reload': 'Tải lại',
  'tableToolBar.density': 'Hiển thị bảng',
  'tableToolBar.densityDefault': 'Mặc định',
  'tableToolBar.densityLarger': 'Rộng',
  'tableToolBar.densityMiddle': 'Trung',
  'tableToolBar.densitySmall': 'Hẹp',

  // ProTable alert
  'alert.clear': 'Bỏ chọn',
  'alert.selected': 'Đã chọn',
  'alert.item': 'mục',

  // ProTable editable
  'editableTable.action.save': 'Lưu',
  'editableTable.action.cancel': 'Hủy',
  'editableTable.action.delete': 'Xóa',

  // ProTable copy
  'copyIconTitle': 'Sao chép',

  // Pagination
  'pagination.total.range': 'Hiển thị',
  'pagination.total.total': 'tổng',
  'pagination.total.item': 'mục',
};
